module.exports = __webpack_public_path__ + "img/Logo---White2x.8f27bc14.png";